export default __webpack_public_path__ + "static/media/p16.78d8e137.jpg";